import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';
import { visibilitySettings } from '../../../utils';

import AlbumGridItemWrapper from './AlbumGridItemWrapper';

const LatestReleaseGridItemWithLogger = D.withVisibilityLogger(
  { contentSection: BackstageConstants.BackstageSections.LATEST_RELEASE },
  visibilitySettings({ isGridComponent: true }),
)(AlbumGridItemWrapper);

const ArtistLatestReleaseGridItem = props => {
  const { latestRelease, isRightRailActive, artistPandoraId, isFirstSection } = props;
  return (
    <D.ContentSection
      isLatestRelease={true}
      title={<FormattedMessage {...BackstageConstants.messages.latestRelease} />}
      isFirstSection={isFirstSection}
    >
      <D.AppContextIntegrationData
        data={{
          contentSection: BackstageConstants.BackstageSections.LATEST_RELEASE,
          pandoraId: get(latestRelease, 'pandoraId', ''),
        }}
      >
        <LatestReleaseGridItemWithLogger
          album={latestRelease}
          artistPandoraId={artistPandoraId}
          twoColumns={!isRightRailActive}
          isFluid={true}
        />
      </D.AppContextIntegrationData>
    </D.ContentSection>
  );
};

ArtistLatestReleaseGridItem.propTypes = {
  latestRelease: PropTypes.object,
  artistPandoraId: PropTypes.string,
  isRightRailActive: PropTypes.bool,
  isFirstSection: PropTypes.bool,
};

export default ArtistLatestReleaseGridItem;
